import React from 'react';
import SpinnerHandler from '../../../hoc/SpinnerHandler/SpinnerHandler';
import Header from '../../UI/Header/Header';
import Footer from '../../UI/Footer/Footer';
import Sidebar from '../../Sidebar/Sidebar';

const Main = (props) => {
  const { children } = props;
  return (
    <SpinnerHandler>
      <Header />
      <Sidebar>{children}</Sidebar>
      <Footer />
    </SpinnerHandler>
  );
};

export default Main;
